import { RNewTasksBrowse } from "@/modules/Tasks/Browse/RNewTasksBrowse";
import { RTasksTemplate } from "@/modules/Tasks/Template/RTasksTemplate";
import { RouteConfig } from "vue-router";

export const REmployerTasks: RouteConfig = {
  path: "tasks",
  component: () =>
    import(
      /* webpackChunkName: "employer-tasks" */
      "./VEmployerTasks.vue"
    ),
  meta: {
    title: "Tasks",
    icon: "create-outline",
    newIcon: "list-check",
    isChild: true,
  },
  children: [RNewTasksBrowse, RTasksTemplate],
};
